export default {
  initAriaFixer(rootElement) {
    if (!rootElement || typeof window === 'undefined') return;

    const interactiveRoles = [
      'button',
      'link',
      'treeitem',
      'menuitem',
      'combobox',
      'gridcell',
      'row',
      'tabpanel'
    ];

    const cleanInvalidAriaExpanded = (root) => {
      const elements = root.querySelectorAll('[aria-expanded]');

      elements.forEach(el => {
        const tag = el.tagName.toLowerCase();
        const role = el.getAttribute('role');
        const tabindex = el.getAttribute('tabindex');
        const hasAriaControls = el.hasAttribute('aria-controls');

        const isInteractive =
          tag === 'button' ||
          tabindex !== null ||
          interactiveRoles.includes(role) ||
          hasAriaControls;

        if (!isInteractive) {
          el.removeAttribute('aria-expanded');
        }
      });
    };

    // Initial scan
    cleanInvalidAriaExpanded(rootElement);

    // Setup MutationObserver
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            cleanInvalidAriaExpanded(node);
          }
        });
      });
    });

    observer.observe(rootElement, {
      childList: true,
      subtree: true
    });

    return observer;
  }
};
